import { IImageMessage, IMessage } from '@/store/messages/messages.ts';
import { INews } from '@/store/news/news.ts';

export const isImageMessage = (msg: IMessage | INews): msg is IImageMessage => {
  return 'image' in msg
}
